/**
 * Shared Sentry config — universal (no Node-only imports), safe to read from
 * the browser, the Cloudflare Worker, and any server module. Single source
 * of truth for the DSN and URL allowlists used by every Sentry init in the
 * codebase. Aliases: sentry dsn, sentry config.
 */

/**
 * The DSN for the unified `dcm` project in Sentry. We previously had a split
 * (`dcm-backend` / `dcm-frontend`); the frontend DSN was retired and the
 * backend project was renamed to `dcm`.
 */
export const SENTRY_DSN =
  "https://2761ae183c669e63682a8a22e70f6cad@o4508840544698368.ingest.de.sentry.io/4508840550727760";

/**
 * Origins from which our own JS/requests originate. Used for both
 * `allowUrls` (drop client events whose stack frames are from third-party
 * scripts) and `tracePropagationTargets` (only attach trace headers to our
 * own backends, not to every third-party fetch).
 */
export const SENTRY_PROPAGATION_TARGETS: Array<RegExp | string> = [
  /^https:\/\/dreamcoachmatch\.com/,
  /^https:\/\/preview\.dreamcoachmatch\.com/,
];
